import { render, staticRenderFns } from "./MarketView.vue?vue&type=template&id=79d93b86&lang=pug"
import script from "./MarketView.vue?vue&type=script&lang=js"
export * from "./MarketView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports